import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { ProfileImage } from '@xing-com/profile-image';
import { spaceS, spaceM } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { CardType as CardTypeBase } from '../components/cards';

const Logo = styled(ProfileImage)`
  margin-right: ${spaceM};
`;

const MainArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-right: ${spaceM};
  overflow: hidden;
`;

const JobTitle = styled(BodyCopy)`
  ${lineClamp(1)}
  margin: 0;
`;

const Location = styled(BodyCopy)`
  ${lineClamp(1)}
  margin: 0;
`;

const CompanyName = styled(BodyCopy)`
  ${lineClamp(1)}
  margin: 0;
`;

const CardType = styled(CardTypeBase)`
  margin: ${spaceS} 0 0 0;
  justify-content: flex-start;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;

  align-items: flex-start;
  justify-content: flex-start;
`;

export { Logo, MainArea, JobTitle, Location, CompanyName, CardType, Container };
